/* Généré par construire.mjs depuis theme-src/animolife.js : module « fiche », chargé après animolife.js. */
(() => {
  "use strict";
  const { $, $$, H, T, agents, ajouterAuPanier, chargerCombo, icone, lienInterdit, memoire, nomPermis, ouvrirFeuille, peindreFavoris, photoEnDonnees, preuve, proposerCombo, publier, remplir, signaler, stockage, toast } = window.animolife.o;
  /* --- Zoom de la vue principale (ZoomPhoto.jsx) --- */
  const MAX = 4;
  const AU_CLIC = 2.5;
  const TOLERANCE_CLIC_PX = 6;
  const BALAYAGE_PX = 48;
  const borner = (v, min, max) => Math.min(max, Math.max(min, v));

  function brancherZoom(cadre, { plein = false, onOuvrir, onBalayage } = {}) {
    const plan = $(".zoom-plan", cadre);
    if (!plan || cadre.dataset.branche) return;
    cadre.dataset.branche = "";
    if (plein) cadre.classList.add("zoom-plein");
    let etat = { s: 1, x: 0, y: 0 };
    let trame = 0;
    let grandeTaille = false;
    const doigts = new Map();
    let pince = null;
    let geste = null;

    const peindre = () => {
      trame = 0;
      plan.style.transform = `translate3d(${etat.x}px, ${etat.y}px, 0) scale(${etat.s})`;
      cadre.dataset.zoom = etat.s > 1 ? "oui" : "non";
      cadre.setAttribute("aria-pressed", etat.s > 1 ? "true" : "false");
    };
    const appliquer = (s, x, y) => {
      const { width: l, height: h } = cadre.getBoundingClientRect();
      s = borner(s, 1, MAX);
      // L'image couvre toujours son cadre : pas de bord vide en déplaçant
      etat = { s, x: borner(x, l - l * s, 0), y: borner(y, h - h * s, 0) };
      if (s > 1 && !grandeTaille) {
        const img = $("img", plan);
        if (img) img.sizes = `${Math.ceil(l * MAX)}px`;
        grandeTaille = true;
      }
      if (!trame) trame = requestAnimationFrame(peindre);
    };
    const zoomerEn = (facteur, px, py) => {
      const s2 = borner(etat.s * facteur, 1, MAX);
      const k = s2 / etat.s;
      appliquer(s2, px - (px - etat.x) * k, py - (py - etat.y) * k);
    };
    const basculer = (px, py) => (etat.s > 1 ? appliquer(1, 0, 0) : zoomerEn(AU_CLIC, px, py));
    const point = (e) => {
      const r = cadre.getBoundingClientRect();
      return [e.clientX - r.left, e.clientY - r.top];
    };

    cadre.addEventListener(
      "wheel",
      (e) => {
        e.preventDefault();
        zoomerEn(Math.exp(-e.deltaY * 0.0015), ...point(e));
      },
      { passive: false },
    );
    cadre.addEventListener("pointerdown", (e) => {
      const p = point(e);
      doigts.set(e.pointerId, p);
      geste = doigts.size === 1 ? { depart: p, clic: true } : null;
      if (doigts.size === 2) {
        const [a, b] = [...doigts.values()];
        pince = { d: Math.hypot(a[0] - b[0], a[1] - b[1]) };
      }
      if (etat.s > 1 || doigts.size === 2) cadre.setPointerCapture?.(e.pointerId);
    });
    cadre.addEventListener("pointermove", (e) => {
      const avant = doigts.get(e.pointerId);
      if (!avant) return;
      const apres = point(e);
      doigts.set(e.pointerId, apres);
      if (geste && Math.hypot(apres[0] - geste.depart[0], apres[1] - geste.depart[1]) > TOLERANCE_CLIC_PX) geste.clic = false;
      if (doigts.size === 2 && pince) {
        const [a, b] = [...doigts.values()];
        const d = Math.hypot(a[0] - b[0], a[1] - b[1]);
        zoomerEn(d / pince.d, (a[0] + b[0]) / 2, (a[1] + b[1]) / 2);
        pince.d = d;
      } else if (doigts.size === 1 && etat.s > 1) {
        appliquer(etat.s, etat.x + apres[0] - avant[0], etat.y + apres[1] - avant[1]);
      }
    });
    const relache = (e) => {
      const [px, py] = point(e);
      const seul = doigts.size === 1;
      const g = geste;
      doigts.delete(e.pointerId);
      if (doigts.size < 2) pince = null;
      if (seul && g && onBalayage && etat.s <= 1 && e.type === "pointerup") {
        const dx = px - g.depart[0];
        if (Math.abs(dx) > BALAYAGE_PX && Math.abs(dx) > Math.abs(py - g.depart[1])) onBalayage(dx < 0 ? 1 : -1);
      }
      // Bouton principal seulement : un clic droit garde son menu
      if (seul && g?.clic && e.button === 0 && e.type === "pointerup") {
        if (onOuvrir && e.pointerType === "touch" && etat.s <= 1) onOuvrir();
        else basculer(px, py);
      }
      geste = null;
    };
    cadre.addEventListener("pointerup", relache);
    cadre.addEventListener("pointercancel", relache);
    cadre.addEventListener("keydown", (e) => {
      const { width: l, height: h } = cadre.getBoundingClientRect();
      const pas = 40;
      const actions = {
        Enter: () => basculer(l / 2, h / 2),
        " ": () => basculer(l / 2, h / 2),
        "+": () => zoomerEn(1.5, l / 2, h / 2),
        "=": () => zoomerEn(1.5, l / 2, h / 2),
        "-": () => zoomerEn(1 / 1.5, l / 2, h / 2),
        0: () => appliquer(1, 0, 0),
        ArrowLeft: () => appliquer(etat.s, etat.x + pas, etat.y),
        ArrowRight: () => appliquer(etat.s, etat.x - pas, etat.y),
        ArrowUp: () => appliquer(etat.s, etat.x, etat.y + pas),
        ArrowDown: () => appliquer(etat.s, etat.x, etat.y - pas),
      };
      const action = actions[e.key];
      // Au plein cadre, les flèches gardent leur rôle habituel
      if (!action || (e.key.startsWith("Arrow") && etat.s <= 1)) return;
      e.preventDefault();
      action();
    });
  }

  /* --- Lecteur vidéo maison (LecteurVideo.jsx) --- */
  const minutes = (s) => {
    const t = Math.max(0, Math.floor(s || 0));
    return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
  };
  function creerLecteur(src, { titre = "", poster = "", autoLecture = false } = {}) {
    const cadre = document.createElement("div");
    cadre.className = "lecteur";
    cadre.setAttribute("role", "group");
    cadre.setAttribute("aria-label", titre);
    cadre.tabIndex = 0;
    cadre.innerHTML = `
      <video playsinline preload="metadata"></video>
      <button type="button" class="lecteur-grand" aria-label="${T.lecture}">${icone("play", 30)}</button>
      <div class="lecteur-barre">
        <button type="button" data-l="lecture" aria-label="${T.lecture}">${icone("play")}</button>
        <input type="range" min="0" max="0" step="0.1" value="0" aria-label="${T.position}">
        <span class="lecteur-temps" aria-hidden="true">0:00 / 0:00</span>
        <button type="button" data-l="son" aria-label="${T.couperSon}" aria-pressed="false">${icone("volume-2")}</button>
        <button type="button" data-l="plein" aria-label="${T.pleinEcran}">${icone("maximize")}</button>
      </div>`;
    const video = $("video", cadre);
    video.src = src;
    if (poster) video.poster = poster;
    const grand = $(".lecteur-grand", cadre);
    const bLecture = $('[data-l="lecture"]', cadre);
    const bSon = $('[data-l="son"]', cadre);
    const curseur = $('input[type="range"]', cadre);
    const temps = $(".lecteur-temps", cadre);

    const basculer = () => (video.paused ? video.play().catch(() => {}) : video.pause());
    const deplacer = (s) => (video.currentTime = Math.min(Math.max(0, s), video.duration || s));
    const couper = () => {
      video.muted = !video.muted;
      bSon.innerHTML = icone(video.muted ? "volume-x" : "volume-2");
      bSon.setAttribute("aria-label", video.muted ? T.remettreSon : T.couperSon);
      bSon.setAttribute("aria-pressed", String(video.muted));
    };
    const pleinEcran = () => (document.fullscreenElement ? document.exitFullscreen?.() : cadre.requestFullscreen?.());
    const etatLecture = (enCours) => {
      cadre.toggleAttribute("data-lecture", enCours);
      grand.hidden = enCours;
      bLecture.innerHTML = icone(enCours ? "pause" : "play");
      bLecture.setAttribute("aria-label", enCours ? T.pause : T.lecture);
    };
    const texteTemps = () => {
      temps.textContent = `${minutes(video.currentTime)} / ${minutes(video.duration)}`;
      curseur.value = video.currentTime;
      curseur.setAttribute("aria-valuetext", temps.textContent);
    };

    video.addEventListener("click", basculer);
    video.addEventListener("play", () => etatLecture(true));
    video.addEventListener("pause", () => etatLecture(false));
    video.addEventListener("ended", () => etatLecture(false));
    video.addEventListener("timeupdate", texteTemps);
    video.addEventListener("loadedmetadata", () => {
      curseur.max = video.duration || 0;
      texteTemps();
    });
    grand.addEventListener("click", basculer);
    bLecture.addEventListener("click", basculer);
    bSon.addEventListener("click", couper);
    $('[data-l="plein"]', cadre).addEventListener("click", pleinEcran);
    curseur.addEventListener("input", () => deplacer(Number(curseur.value)));
    cadre.addEventListener("keydown", (e) => {
      if (e.target.type === "range") return;
      const action = { " ": basculer, k: basculer, m: couper, f: pleinEcran, ArrowRight: () => deplacer(video.currentTime + 5), ArrowLeft: () => deplacer(video.currentTime - 5) }[e.key];
      if (!action) return;
      e.preventDefault();
      action();
    });
    if (autoLecture) {
      // Choisie d'un clic : elle part tout de suite, le clic vaut autorisation du son
      video.play().catch(() => {
        // Refusée malgré tout (réglage du navigateur) : sans le son, elle passe
        video.muted = false;
        couper();
        video.play().catch(() => {});
      });
    }
    return cadre;
  }
  for (const place of $$("[data-lecteur]")) {
    place.replaceWith(creerLecteur(place.dataset.lecteur, { titre: place.dataset.titre, poster: place.dataset.poster }));
  }

  /* --- Visionneuse plein écran, au doigt (Visionneuse.jsx) --- */
  function ouvrirVisionneuse(photos, depart) {
    if (!photos.length) return;
    let i = Math.max(0, depart);
    const racine = document.documentElement;
    const debordement = racine.style.overflow;
    const focusAvantVisionneuse = document.activeElement;
    const el = document.createElement("div");
    el.className = "visionneuse";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-label", document.querySelector("#fiche-titre")?.textContent || "");
    el.innerHTML = `
      <div class="visionneuse-barre">
        <p class="visionneuse-compte" aria-live="polite"></p>
        <button type="button" class="visionneuse-fermer" aria-label="${T.fermer}">${icone("x", 24)}</button>
      </div>
      <div class="visionneuse-cadre"></div>
      <p class="visionneuse-aide" id="visionneuse-aide">${photos.length > 1 ? T.aidePlein : T.aidePleinUne}</p>`;
    const cadreParent = $(".visionneuse-cadre", el);
    const peindre = () => {
      $(".visionneuse-compte", el).textContent = `${i + 1} / ${photos.length}`;
      const p = photos[i];
      cadreParent.innerHTML = `<div class="zoom" data-zoom="non" tabindex="0" role="button" aria-pressed="false" aria-describedby="visionneuse-aide"><div class="zoom-plan"><img class="art art-photo" alt="" sizes="100vw"></div></div>`;
      const img = $("img", cadreParent);
      if (p.srcset) img.srcset = p.srcset;
      img.src = p.src;
      brancherZoom($(".zoom", cadreParent), { plein: true, onBalayage: photos.length > 1 ? aller : undefined });
    };
    const aller = (pas) => {
      i = (i + pas + photos.length) % photos.length;
      peindre();
    };
    const fermer = () => {
      el.remove();
      racine.style.overflow = debordement;
      document.removeEventListener("keydown", clavier, true);
      focusAvantVisionneuse?.focus?.();
    };
    const clavier = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        fermer();
      } else if ((e.key === "ArrowRight" || e.key === "ArrowLeft") && photos.length > 1 && !e.defaultPrevented) {
        const zoom = $(".zoom", el);
        if (zoom?.dataset.zoom === "oui") return;
        e.preventDefault();
        aller(e.key === "ArrowRight" ? 1 : -1);
      }
    };
    $(".visionneuse-fermer", el).addEventListener("click", fermer);
    document.addEventListener("keydown", clavier, true);
    racine.style.overflow = "hidden";
    document.body.append(el);
    peindre();
    $(".visionneuse-fermer", el).focus();
  }

  /* --- Fiche produit --- */
  const fiche = $("[data-fiche]");
  if (fiche) {
    const donnees = JSON.parse($("[data-produit-json]").textContent);
    const form = $("[data-form-produit]", fiche);
    const champId = $("[data-id-variante]", fiche);
    const champQte = $("[data-quantite-champ]", fiche);
    const sortie = $("[data-quantite]", fiche);
    const moins = $("[data-moins]", fiche);
    const plus = $("[data-plus]", fiche);
    const galerie = $("[data-galerie]");
    const principale = $("[data-vue-principale]");
    const vignettes = $$("[data-vignettes] [role='radio']");
    let variante = donnees.variantes.find((v) => String(v.id) === champId.value) || donnees.variantes[0];
    let quantite = 1;

    // Vus récemment
    const recents = stockage.lire("recent", []).filter((h) => h !== donnees.handle);
    recents.unshift(donnees.handle);
    stockage.ecrire("recent", recents.slice(0, 8));

    const max = () => (variante.stock === null ? 99 : Math.max(1, variante.stock));
    const peindreQuantite = () => {
      sortie.textContent = quantite;
      champQte.value = quantite;
      moins.disabled = quantite <= 1;
      plus.disabled = quantite >= max();
      const total = new Intl.NumberFormat(H.langue, { style: "currency", currency: window.Shopify?.currency?.active || "EUR" }).format((variante.prix * quantite) / 100);
      $("[data-prix-total]", fiche).textContent = total;
    };
    moins?.addEventListener("click", () => {
      quantite = Math.max(1, quantite - 1);
      peindreQuantite();
    });
    plus?.addEventListener("click", () => {
      quantite = Math.min(max(), quantite + 1);
      peindreQuantite();
    });

    const peindreVariante = () => {
      champId.value = variante.id;
      $("[data-prix]", fiche).textContent = variante.prixTexte;
      $("[data-prix-barre]")?.replaceChildren(variante.prixTexte);
      // La plaque, à côté de la photo sur ordinateur : même prix, même prix barré, bouton grisé si épuisé
      $("[data-plaque-prix]")?.replaceChildren(variante.prixTexte);
      const avantPlaque = $("[data-plaque-avant]");
      if (avantPlaque) {
        avantPlaque.hidden = !variante.avant;
        $("[data-plaque-avant-valeur]").textContent = variante.avantTexte || "";
        $("[data-plaque-bloc-prix]")?.classList.toggle("prix-solde", Boolean(variante.avant));
      }
      const ajoutPlaque = $("[data-plaque-ajout]");
      if (ajoutPlaque) ajoutPlaque.disabled = !variante.disponible;
      // Prix d'origine et plaque suivent la déclinaison : une couleur peut être soldée, l'autre non
      const solde = Boolean(variante.avant);
      $("[data-bloc-prix]", fiche)?.classList.toggle("prix-solde", solde);
      $("[data-prix-avant]", fiche).hidden = !solde;
      $("[data-prix-maintenant]", fiche).hidden = !solde;
      $("[data-prix-avant-valeur]", fiche).textContent = variante.avantTexte || "";
      const pourcent = solde ? Math.round(((variante.avant - variante.prix) * 100) / variante.avant) : 0;
      $("[data-remise]", fiche).innerHTML = pourcent > 0 ? `<span class="plaque-remise" aria-hidden="true">${remplir(T.remise, { n: pourcent })}</span>` : "";
      const stock = $("[data-stock]", fiche);
      if (!variante.disponible) stock.innerHTML = `<span class="stock stock-out">${T.epuise}</span>`;
      else if (variante.stock !== null && variante.stock <= 4) stock.innerHTML = `<span class="stock stock-low">${remplir(T.plusQue, { n: variante.stock })}</span>`;
      else stock.innerHTML = `<span class="stock">${T.enStock}</span>`;
      $("[data-epuise]", fiche).hidden = variante.disponible;
      $("[data-bloc-achat]", fiche).hidden = !variante.disponible;
      $$("fieldset[data-option]", fiche).forEach((fs, n) => {
        const choix = $("[data-choix-option]", fs);
        if (choix) choix.textContent = variante.options[n];
      });
      quantite = 1;
      peindreQuantite();
      // Un pack est un autre produit : l'adresse garde la déclinaison de la fiche
      if (!variante.pack) {
        const url = new URL(location.href);
        url.searchParams.set("variant", variante.id);
        history.replaceState(null, "", url);
      }
      // La photo de la couleur choisie passe au premier plan
      if (variante.media) vignettes.find((b) => b.dataset.mediaId === String(variante.media))?.click();
    };
    // Formules : deux exemplaires (à côté de la photo, près du bouton), cochés pareil
    document.addEventListener("change", (e) => {
      if (!e.target.closest?.("[data-formules]")) return;
      $$("[data-formules] input").forEach((r) => (r.checked = r.value === e.target.value));
      variante = donnees.variantes.find((v) => String(v.id) === e.target.value) || variante;
      peindreVariante();
      publier("formule_choisie", { variante: variante.id, pack: Boolean(variante.pack) });
    });
    // La formule cochée d'avance (réglage du thème) : la fiche s'ouvre sur son prix
    const formuleDefaut = $("[data-formules] input[data-defaut]", fiche);
    if (formuleDefaut && !new URLSearchParams(location.search).has("variant")) {
      const choisie = donnees.variantes.find((v) => String(v.id) === formuleDefaut.value);
      if (choisie && choisie.disponible) {
        $$("[data-formules] input").forEach((r) => (r.checked = r.value === formuleDefaut.value));
        variante = choisie;
        peindreVariante();
      }
    }
    form?.addEventListener("change", (e) => {
      if (!e.target.name?.startsWith("option-")) return;
      const choix = $$("fieldset[data-option]", fiche).map((fs) => $("input:checked", fs)?.value);
      variante = donnees.variantes.find((v) => v.options.every((o, n) => o === choix[n])) || variante;
      peindreVariante();
    });

    form?.addEventListener("submit", async (e) => {
      e.preventDefault();
      const bouton = $("[data-ajout-fiche]", fiche);
      bouton.disabled = true;
      try {
        const panier = await ajouterAuPanier(variante.id, quantite);
        if (variante.pack || !(await proposerCombo(donnees.handle, donnees.id, panier))) ouvrirFeuille("panier");
      } catch (err) {
        toast(err.message);
      } finally {
        bouton.disabled = false;
      }
    });

    // Barre d'achat mobile, dès que le bouton principal sort de l'écran
    const bloc = $("[data-bloc-achat]", fiche);
    const barre = $("[data-barre-achat]");
    if (bloc && barre && "IntersectionObserver" in window) {
      // Sans déclinaison, la barre est là dès l'arrivée (le bouton est sous la photo, hors écran) ;
      // avec des couleurs, elle attend qu'on ait dépassé le choix pour ne pas ajouter la mauvaise
      const sansChoix = donnees.variantes.length === 1;
      new IntersectionObserver(([entree]) => {
        const visible = !entree.isIntersecting && (sansChoix || entree.boundingClientRect.top < 0) && variante.disponible;
        barre.toggleAttribute("data-visible", visible);
        barre.setAttribute("aria-hidden", String(!visible));
        $("[data-barre-ajout]", barre).tabIndex = visible ? 0 : -1;
      }).observe(bloc);
      $("[data-barre-ajout]", barre).addEventListener("click", () => form.requestSubmit());
    }

    // Galerie : vignettes, zoom, vidéo, visionneuse et balayage
    const photos = vignettes
      .filter((b) => b.dataset.type === "image")
      .map((b) => ({ id: b.dataset.mediaId, src: b.dataset.src, srcset: b.dataset.srcset, alt: b.dataset.alt }));
    if (!photos.length) {
      const img = $("img", principale || document.createElement("div"));
      if (img) photos.push({ id: "", src: img.src, srcset: img.srcset, alt: img.alt });
    }
    let courante = Math.max(0, vignettes.findIndex((b) => b.getAttribute("aria-checked") === "true"));

    const brancherVue = () => {
      const zoom = $(".zoom", principale);
      if (!zoom) return;
      brancherZoom(zoom, {
        onOuvrir: () => {
          const id = vignettes[courante]?.dataset.mediaId;
          ouvrirVisionneuse(photos, Math.max(0, photos.findIndex((p) => p.id === id)));
        },
        onBalayage: vignettes.length > 1 ? (pas) => montrer((courante + pas + vignettes.length) % vignettes.length, false) : undefined,
      });
    };
    const montrer = (n, lancer) => {
      const b = vignettes[n];
      if (!b) return;
      courante = n;
      principale.style.setProperty("--ratio", b.dataset.ratio || "1");
      vignettes.forEach((v, k) => {
        v.setAttribute("aria-checked", String(k === n));
        v.tabIndex = k === n ? 0 : -1;
      });
      const libelle = remplir(T.vueDe, { name: donnees.titre, n: n + 1, total: vignettes.length });
      const aide = $("#zoom-aide");
      if (b.dataset.type === "video") {
        principale.replaceChildren(creerLecteur(b.dataset.video, { titre: libelle, poster: b.dataset.poster, autoLecture: lancer }));
        if (aide) aide.hidden = true;
      } else {
        principale.innerHTML = `<div class="zoom" data-zoom="non" tabindex="0" role="button" aria-pressed="false" aria-describedby="zoom-aide"><div class="zoom-plan"><img class="art art-photo" sizes="(min-width: 56rem) 34rem, 100vw"></div></div>`;
        const zoom = $(".zoom", principale);
        zoom.setAttribute("aria-label", libelle);
        const img = $("img", principale);
        img.alt = b.dataset.alt || "";
        img.srcset = b.dataset.srcset;
        img.src = b.dataset.src;
        if (aide) aide.hidden = false;
        brancherVue();
      }
    };
    vignettes.forEach((b, n) => b.addEventListener("click", () => montrer(n, true)));
    $("[data-vignettes]")?.addEventListener("keydown", (e) => {
      const pas = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!pas) return;
      e.preventDefault();
      const suivante = (courante + pas + vignettes.length) % vignettes.length;
      montrer(suivante, false);
      vignettes[suivante].focus();
    });
    if (galerie) brancherVue();
    peindreQuantite();
    // Le combo est prêt avant le clic : la feuille s'ouvre sans attente
    chargerCombo(donnees.handle, donnees.id);

    // Suggestions : rendues par Shopify, chargées à l'approche
    const zone = $("[data-suggestions]");
    if (zone) {
      fetch(zone.dataset.suggestions)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const contenu = $(".shopify-section", doc) || doc.body;
          if ($("[data-case]", contenu)) {
            zone.innerHTML = contenu.innerHTML;
            zone.hidden = false;
            peindreFavoris();
          }
        })
        .catch(() => {});
    }
  }

  /* --- Avis : huit cartes d'abord, les autres sur demande --- */
  const plusAvis = $("[data-avis-plus]");
  plusAvis?.addEventListener("click", () => {
    const ouvert = plusAvis.getAttribute("aria-expanded") === "true";
    for (const c of $$("[data-avis-cache]")) c.hidden = ouvert;
    plusAvis.setAttribute("aria-expanded", String(!ouvert));
    plusAvis.textContent = ouvert ? plusAvis.dataset.libellePlus : plusAvis.dataset.libelleMoins;
  });

  /* --- Donner son avis : réservé aux clients connectés qui ont acheté l'objet (avis.py) --- */
  const ecrire = $("[data-avis-ecrire]");
  if (ecrire) {
    const api = (H.agents || "/apps/hanabi").replace(/\/$/, "");
    const produit = ecrire.dataset.produit;
    const ouvrir = $("[data-avis-ouvrir]", ecrire);
    const panneau = $(".avis-panneau", ecrire);
    const form = $("[data-avis-form]", ecrire);
    const montrer = (etat, texte) => {
      for (const el of $$("[data-avis-etat]", panneau)) el.hidden = el.dataset.avisEtat !== etat;
      const courant = $(`[data-avis-etat="${etat}"]`, panneau);
      if (etat === "erreur") courant.textContent = texte;
      return courant;
    };
    // Le serveur dit si ce client peut donner son avis, avant qu'il ne l'écrive
    const verifierDroit = async () => {
      if (!ecrire.hasAttribute("data-connecte")) return montrer("visiteur");
      montrer("verification");
      try {
        const r = await fetch(`${api}/avis/droit?produit=${encodeURIComponent(produit)}`);
        if (!r.ok) throw new Error();
        const droit = await r.json();
        if (!droit.connecte) montrer("visiteur");
        else if (!droit.achete) montrer("non-achete");
        else if (droit.deja) montrer("deja");
        else {
          montrer("formulaire");
          $('input[name="note"]', form)?.focus();
        }
      } catch {
        montrer("erreur", T.avisVerifErreur);
      }
    };
    ouvrir.addEventListener("click", () => {
      const ouvre = panneau.hidden;
      panneau.hidden = !ouvre;
      ouvrir.setAttribute("aria-expanded", String(ouvre));
      if (ouvre) verifierDroit();
    });

    form?.addEventListener("submit", async (e) => {
      e.preventDefault();
      const note = Number($('input[name="note"]:checked', form)?.value || 0);
      const nom = form.elements.nom;
      const texte = form.elements.texte;
      const texteLien = lienInterdit.test(texte.value);
      const fautes = [
        signaler("avis-note-err", !note) && $('input[name="note"]', form),
        signaler("avis-nom-err", nom.value.trim().length < 2 || !nomPermis.test(nom.value.trim()), nom) && nom,
        signaler("avis-texte-err", texte.value.trim().length < 10, texte) && texte,
        signaler("avis-texte-lien-err", texteLien, texteLien ? texte : null) && texte,
      ].filter(Boolean);
      if (fautes.length) return fautes[0].focus();
      const bouton = $('button[type="submit"]', form);
      bouton.disabled = true;
      bouton.textContent = bouton.dataset.libelleAttente;
      try {
        const fichier = form.elements.photo.files[0];
        const photo = fichier ? await photoEnDonnees(fichier) : null;
        const antibot = await preuve(api, "avis", $(".honeypot", form));
        const r = await fetch(`${api}/avis`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ produit, note, nom: nom.value.trim(), texte: texte.value.trim(), photo, antibot }),
        });
        // Les refus du serveur sont traduits ici, dans la langue de la page
        if (r.status === 401) return montrer("visiteur");
        if (r.status === 403) return montrer("non-achete");
        if (r.status === 409) return montrer("deja");
        if (r.status === 429) return montrer("erreur", T.avisLimite);
        if (!r.ok) throw new Error();
        const resultat = await r.json();
        memoire.oublier("espace");
        const merci = montrer("merci");
        const titre = $("[data-avis-merci]", merci);
        titre.textContent = resultat.publie ? titre.dataset.textePublie : titre.dataset.texteBrouillon;
        const remarque = $("[data-avis-remarque]", merci);
        remarque.hidden = !resultat.remarque;
        if (resultat.remarque) remarque.textContent = resultat.remarque;
        merci.focus();
      } catch {
        montrer("erreur", T.avisErreur);
        form.hidden = false;
      } finally {
        bouton.disabled = false;
        bouton.textContent = bouton.dataset.libelle;
      }
    });
    $("[data-avis-actualiser]", ecrire)?.addEventListener("click", () => location.reload());
    if (location.hash === "#avis-donner") {
      $("#avis")?.scrollIntoView();
      ouvrir.click();
    }
  }

  /* --- Alerte de retour en stock (alertes.py) : un e-mail au retour de l'objet ; sans le serveur, le formulaire de contact prend le relais --- */
  // Le lien de l'e-mail de confirmation ramène ici avec ?alerte= : le jeton est envoyé une fois, puis retiré de l'adresse
  const jetonAlerte = new URLSearchParams(location.search).get("alerte");
  if (jetonAlerte) {
    const propre = new URL(location.href);
    propre.searchParams.delete("alerte");
    history.replaceState(history.state, "", propre);
    fetch(`${agents}/alerte/confirmer`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ jeton: jetonAlerte }) })
      .then((r) => toast(r.ok ? T.alerteOk : T.alerteLienPerime))
      .catch(() => toast(T.alerteLienPerime));
  }
  const alerte = $("#alerte-stock");
  if (alerte && alerte.dataset.produit && !$(".notify-ok", alerte)) {
    alerte.addEventListener("submit", async (e) => {
      const champ = $('input[type="email"]', alerte);
      // Une adresse mal formée part chez Shopify, qui l'explique sous le champ
      if (!champ?.checkValidity()) return;
      e.preventDefault();
      const bouton = $('button[type="submit"]', alerte);
      bouton.disabled = true;
      try {
        const antibot = await preuve(agents, "alerte", null);
        const r = await fetch(`${agents}/alerte`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ produit: alerte.dataset.produit, email: champ.value.trim(), langue: H.langue, antibot }),
        });
        if (!r.ok) throw new Error(String(r.status));
        const rendu = await r.json();
        if (rendu.disponible) return location.reload();
        const ok = document.createElement("p");
        ok.className = "notify-ok";
        ok.setAttribute("role", "status");
        // Une adresse encore jamais confirmée reçoit d'abord un lien : sans lui, aucune alerte ne part
        ok.textContent = rendu.confirmer ? T.alerteConfirmer : T.alerteOk;
        alerte.replaceChildren($("h2", alerte), ok);
      } catch {
        alerte.submit();
      } finally {
        bouton.disabled = false;
      }
    });
  }

})();
